<template>
    <div v-if="bizAuth.viewTask.hasRight" class="page-setting biz-task-management parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <task-tutorial></task-tutorial>
        <task-done-filter :isOpen="filterStatus.done" @filterClose="closeFilterMenu"></task-done-filter>
        <task-process-filter :isOpen="filterStatus.process" @filterClose="closeFilterMenu"></task-process-filter>
        <task-unpaid-filter :isOpen="filterStatus.unpaid" @filterClose="closeFilterMenu"></task-unpaid-filter>
        <payment-all></payment-all>
        <task-payment-record></task-payment-record>
        <div class="tool-bar-mask"></div>
        <div class="page-header has-tab">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <table-search @changeWord="setFilterWord" :setDefault="isProcessDefault || isDoneDefault || isUnpaidDefault"></table-search>
                <div class="filter" @click="openFilter()">
                    <img src="@/assets/img/icon/filter_black.svg" alt="">
                </div>
                <div v-if="bizAuth.payTask.hasRight && decodeURIComponent(this.$route.hash) == '#待付款'" @click="openPaymentAll" class="default-button pay-all">
                    總金額 {{toCurrency(unpaidAmountTotal)}} 委託付款
                </div>
                <dot-large-drop-menu bg="#ff9275" bgHover="#eb7859">
                    <ul >
                        <li v-if="bizAuth.createTask.hasRight" @click="toPage('bizNewTask')">
                            新增委託
                        </li>
                        <li @click="openTaskTutorial()">
                            委託說明
                        </li>
                        <li v-if="bizAuth.viewTaskRecord.hasRight" @click="openTaskRecord()">查看付款紀錄</li> 
                    </ul>
                </dot-large-drop-menu >
            </div>
        </div>
        <tabs :key="componentKey">
            <tab name="進行中" :selected="selected.process">
                <task-process-list v-if="selected.process"></task-process-list>
            </tab>
            <tab name="待付款" :selected="selected.unpaid">
                <task-unpaid-list v-if="selected.unpaid"></task-unpaid-list>
            </tab>
            <tab name="已結束" :selected="selected.finished">
                <task-done-list v-if="selected.finished"></task-done-list>
            </tab>
        </tabs>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import TaskProcessList from '@/components/bussiness/mgtCategory/taskMgt/taskProcess/taskProcessList.vue';
import TaskDoneList from '@/components/bussiness/mgtCategory/taskMgt/taskDone/taskDoneList.vue';
import TaskUnpaidList from '@/components/bussiness/mgtCategory/taskMgt/taskUnpaid/taskUnpaidList.vue';
import TaskTutorial from '@/components/bussiness/widges/modals/taskTutorial.vue';
import taskDoneFilter from '@/components/bussiness/mgtCategory/taskMgt/taskDone/taskDoneFilter.vue';
import taskProcessFilter from '@/components/bussiness/mgtCategory/taskMgt/taskProcess/taskProcessFilter.vue';
import taskUnpaidFilter from '@/components/bussiness/mgtCategory/taskMgt/taskUnpaid/taskUnpaidFilter.vue';
import DotLargeDropMenu from '@/components/widge/DotLargeDropMenu.vue';
import paymentAll from '@/components/bussiness/widges/modals/paymentAll.vue';
import taskPaymentRecord from '@/components/bussiness/widges/modals/taskPaymentRecord.vue';

import { mapGetters } from 'vuex'


export default {
    data () {
        return {
            listIsFixed: false,
            myHeight: (window.innerHeight - 84) + 'px',
            componentKey: 0,
            selected: {
                process: false,
                finished: false,
                unpaid: false
            },
            filterStatus: {
                done: false,
                process: false,
                unpaid: false
            },
            
        }
    },
    created (){
        this.selectTabByHash()
    },
    mounted () {
        this.$analyticsBiz.logEvent('委託房客', { screen_name: '委託房客'})
        window.addEventListener('scroll', this.handleScroll);
        console.log(this.$cookie.get('isFirstTask'))
        if(!this.$cookie.get('notFirstTask')){
            this.openTaskTutorial()
            this.$cookie.set('notFirstTask', true, { expires: '1Y' });
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
        }
        
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                this.forceUpdate()
                this.closeFilterMenu()
            },
            // immediate: true,
            deep: true
        },
        'bizAuth.viewTask.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        toPage: function (page) {
            if(this.verifiedStatus === 'NORMAL'){
                this.$router.push({name: page})
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        },
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        openTaskTutorial: function () {
            this.$analyticsBiz.logEvent('委託說明', { screen_name: '委託說明'})
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizTaskTutorial'})
        },
        openTaskRecord: function () {
            if(this.verifiedStatus === 'NORMAL'){
                this.$analyticsBiz.logEvent('查看付款紀錄', { screen_name: '查看付款紀錄'})
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizTaskPaymentRecord'})
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        },
        openFilter: function () {
            let hashTag = decodeURIComponent(this.$route.hash)
            this.$store.commit('modalStatus/set_filter_mode', true)
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
            if( hashTag == '#進行中' ){
                this.filterStatus.process = true
            }else if( hashTag == '#已結束' ){
                this.filterStatus.done = true
            }else if( hashTag == '#待付款' ){
                this.filterStatus.unpaid = true
            }else{
                this.filterStatus.process = true
            }
        },
        openPaymentAll: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizPaymentAll'})
        },
        closeFilterMenu: function (value) {
            this.$store.commit('modalStatus/set_filter_mode', false)
            this.filterStatus.process = false
            this.filterStatus.done = false
            this.filterStatus.unpaid = false
        },
        setFilterWord: function (value) {
            let hashTag = decodeURIComponent(this.$route.hash)
            if( hashTag == '#進行中' ){
                this.$store.dispatch('setBizTaskProcessMgtFilterWord', value)
            }else if( hashTag == '#已結束' ){
                this.$store.dispatch('setBizTaskDoneMgtFilterWord', value)
            }else if( hashTag == '#待付款' ){
                this.$store.dispatch('setBizTaskUnpaidMgtFilterWord', value)
            }else{
                this.$store.dispatch('setBizTaskProcessMgtFilterWord', value)
            }
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)

            if( hashTag == '#進行中' ){
                this.$analyticsBiz.logEvent('委託房客_進行中', { screen_name: '委託房客_進行中'})
                this.selected.process = true
            }else if( hashTag == '#已結束' ){
                this.$analyticsBiz.logEvent('委託房客_已結束', { screen_name: '委託房客_已結束'})
                this.selected.finished = true
            }else if( hashTag == '#待付款' ){
                this.$analyticsBiz.logEvent('委託房客_待付款', { screen_name: '委託房客_待付款'})
                this.selected.unpaid = true
            }else{
                this.$analyticsBiz.logEvent('委託房客_進行中', { screen_name: '委託房客_進行中'})
                this.selected.process = true
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.process = false
            this.selected.finished = false
            this.selected.unpaid = false
            
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        }
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            isModalMode: 'GET_MODAL_MODE',
            unpaidAmountTotal: 'GET_BIZ_TASK_UNPAID_MGT_UNPAID_AMOUNG_TOTAL',
            isProcessDefault: 'GET_BIZ_TASK_PROCESS_MGT_FILTER_DEFAULT',
            isDoneDefault: 'GET_BIZ_TASK_DONE_MGT_FILTER_DEFAULT',
            isUnpaidDefault: 'GET_BIZ_TASK_UNPAID_MGT_FILTER_DEFAULT',
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED'
        })
    },
    components: {
        Tabs,
        Tab,
        Breadcrumb,
        TaskProcessList,
        TaskDoneList,
        TaskUnpaidList,
        TableSearch,
        TaskTutorial,
        taskDoneFilter,
        DotLargeDropMenu,
        paymentAll,
        taskProcessFilter,
        taskUnpaidFilter,
        taskPaymentRecord
    }
}
</script>
<style lang="scss">
    .biz-task-management{
       .page-header{
            .btn-group{
                .pay-all{
                  padding: 14px 24px;  
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/taskMgt/taskMgtDefault.vue